





















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import EmptyContent from "@/components/EmptyContent";
import LevelItem from "./LevelItem.vue";

export default defineComponent({
  name: "LevelsView",
  components: { LevelItem, EmptyContent, BaseButton },
  props: {
    priceList: { type: Array as PropType<SubscriptionLevel[]>, required: true },
    packageList: { type: Array as PropType<PaymentPackage[]>, required: true },
  },
  setup(props) {
    const description = computed(() => {
      if (props.priceList.length < 2) return $t("This is the monthly subscription price for your page");
      return $t("Here are different monthly subscription levels for your page");
    });
    return {
      description,
    };
  },
});
